import Icon from '@ant-design/icons/lib/components/Icon';
import { ReactComponent as OrganizationIconComponent } from 'assets/images/icons/organization.min.svg';
import { ReactComponent as OrganizationFilledIconComponent } from 'assets/images/icons/organization-filled.min.svg';
import React from 'react';

type Props = React.ComponentProps<typeof Icon> & {
  filled?: boolean;
};

export const OrganizationIcon: React.FC<Props> = ({ filled, ...props }) => {
  return (
    <Icon
      {...props}
      component={filled ? OrganizationFilledIconComponent : OrganizationIconComponent}
      style={{ fontSize: props.size, ...props.style }}
    />
  );
};
